import CLoadInProgress from "./CLoadInProgress";

export const renderLoader = () => <CLoadInProgress/>;